module.exports = __webpack_public_path__ + "img/family-3.0928092b.jpg";